import {
  BrandingKey,
  BuilderKey,
  ControlKey,
  GuardKey,
  MicrositePageKey,
  PreviewKey,
  PublishKey,
  TabsKey
} from '../../TModules';
import { MicrositeTranslations } from '../en/translations';

export const translations: MicrositeTranslations = {
  [MicrositePageKey]: {
    OtherSettings: 'Weitere Einstellungen',
    SettingUpdated: 'Einstellung aktualisiert',
    FailedToUpdateSetting: 'Einstellung konnte nicht aktualisiert werden',
    Loading: 'Wird geladen',
    LoadError: 'Einstellungen konnten nicht geladen werden',
    AllowCustomNickname: 'Benutzern erlauben, einen benutzerdefinierten Spitznamen festzulegen',
    AllowCustomNicknameSubtext:
      'Wenn aktiviert, können Microsite-Benutzer einen eindeutigen Spitznamen in ihrem Profil festlegen, der als ihre alternative ID verwendet wird.'
  },
  [TabsKey]: {
    Details: 'Details',
    Branding: 'Branding',
    Microsite: 'Microsite',
    ControlSettings: 'Steuerungseinstellungen'
  },
  [BrandingKey]: {
    Cards: {
      BrandIdentity: 'Markenidentität',
      Typography: 'Typografie',
      BackgroundColors: 'Hintergrundfarben',
      TextColors: 'Textfarben',
      SemanticColors: 'Semantische Farben',
      AccentColors: 'Akzentfarben',
      Others: 'Sonstiges',
      Buttons: 'Schaltflächen'
    },
    Tooltips: {
      BrandIdentity:
        'Konfigurieren Sie die zentrale Markenidentität der gesamten Experience, einschließlich Anwendungsname, Markenfarben, Logo und globalem Eckenradius.',
      Typography:
        'Legen Sie die Schriftfamilie fest, die in der gesamten Experience für eine einheitliche Typografie und gute Lesbarkeit verwendet wird.',
      BackgroundColors:
        'Konfigurieren Sie Hintergrundfarben für wichtige Bereiche der Experience, einschließlich Abschnitten, App-Kopfzeile, App-Hintergrund und Hero-Bereichen.',
      TextColors:
        'Legen Sie Farben für Überschriften, Fließtext, ergänzenden Text und Links fest, um ein einheitliches und gut lesbares Textbild zu gewährleisten.',
      SemanticColors:
        'Legen Sie Standardfarben fest, die Bedeutung und Status vermitteln, z. B. Erfolg, Warnung, Fehler, Information, neutrale und Werbezustände.',
      AccentColors:
        'Konfigurieren Sie zusätzliche Farben für Hervorhebungen, visuelle Elemente und UI-Komponenten in der gesamten Experience.',
      Others:
        'Konfigurieren Sie zusätzliche Farben für Oberflächenelemente wie primäre und sekundäre Symbole.',
      Buttons:
        'Konfigurieren Sie das Aussehen primärer und sekundärer Schaltflächen, einschließlich Füllung, Text, Rahmen, deaktivierter Zustände, Höhe und Eckenradius.'
    },
    Fields: {
      title: 'Anwendungsname',
      primary_color: 'Primäre Markenfarbe',
      secondary_color: 'Sekundäre Markenfarbe',
      logo: 'Logobild',
      border_radius: 'Globaler Eckenradius',
      font: 'Schriftfamilie',
      bg_primary_color: 'Primär',
      bg_secondary_color: 'Sekundär',
      bg_tertiary_color: 'Tertiär',
      bg_alternative_color: 'Alternativ',
      header_color: 'App-Kopfzeile',
      app_bg_color: 'App-Hintergrund',
      font_color: 'Primär',
      text_secondary_color: 'Sekundär',
      text_tertiary_color: 'Tertiär',
      link_color: 'Link',
      success_color: 'Erfolg',
      warning_color: 'Warnung',
      error_color: 'Fehler',
      information_color: 'Information',
      neutral_color: 'Neutral',
      promotional_color: 'Werbung',
      accent_color: 'Akzent 1',
      accent_2_color: 'Akzent 2',
      accent_3_color: 'Akzent 3',
      accent_4_color: 'Akzent 4',
      accent_5_color: 'Akzent 5',
      accent_6_color: 'Akzent 6',
      icon_primary_color: 'Primäres Symbol',
      icon_secondary_color: 'Sekundäres Symbol',
      CTA_button_bg_color: 'Füllung',
      CTA_button_text_color: 'Textfarbe',
      CTA_button_disabled_bg_color: 'Deaktivierte Füllung',
      CTA_button_disabled_text_color: 'Deaktivierter Text',
      secondary_button_bg_color: 'Füllung',
      secondary_button_border_color: 'Rahmen',
      secondary_button_text_color: 'Textfarbe',
      secondary_button_disabled_bg_color: 'Deaktivierte Füllung',
      secondary_button_disabled_border_color: 'Deaktivierter Rahmen',
      secondary_button_disabled_text_color: 'Deaktivierter Text',
      button_height: 'Schaltflächenhöhe (px)',
      button_border_radius: 'Eckenradius (px)'
    },
    Help: {
      PrimaryColor: 'Die Primärfarbe wird z. B. für Hervorhebungen in Fortschrittsbalken verwendet',
      Logo: 'PNG oder SVG, 120 × 30 px empfohlen',
      BorderRadius: 'Wird global auf Karten, Eingabefelder und Badges angewendet.'
    },
    Radius: {
      Small: 'Klein - 4px',
      Medium: 'Mittel - 8px',
      Large: 'Groß - 16px',
      Sharp: 'Eckig - 0px'
    },
    Px: 'px',
    Replace: 'Ersetzen',
    TooltipLabel: 'Über {{section}}',
    ResetToDefault: 'Auf Standard zurücksetzen',
    Reset: 'Zurücksetzen',
    Save: 'Änderungen speichern',
    Sample: 'Beispiel',
    SampleText: 'Franz jagt im komplett verwahrlosten Taxi',
    UnsupportedFont: '{{font}} (nicht unterstützt)',
    Preview: 'Vorschau',
    PreviewHeading: 'Überschrift',
    PreviewBody: 'Beispiel für Fließtext',
    PreviewCaption: 'Bildunterschrift oder Hilfetext',
    PreviewLink: 'Linktext',
    PrimaryButton: 'Primäre Schaltfläche',
    SecondaryButton: 'Sekundäre Schaltfläche',
    SharedSizing: 'Gemeinsame Größen',
    ButtonPrimary: 'Primär',
    ButtonSecondary: 'Sekundär',
    ButtonSmall: 'Klein',
    ButtonDisabled: 'Deaktiviert',
    Errors: {
      Required: 'Dieses Feld ist erforderlich',
      invalid_hex: 'Geben Sie eine gültige HEX-Farbe ein, z. B. #0284C7',
      logo_required: 'Das Logobild ist erforderlich',
      unsupported_font:
        'Diese Schriftart wird nicht mehr unterstützt. Wählen Sie eine andere Schriftart.',
      invalid_integer: 'Geben Sie eine ganze Zahl ab 0 ein'
    },
    Toasts: {
      Saved: 'Branding gespeichert',
      SaveFailed: 'Branding konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      FixErrors: 'Bitte korrigieren Sie die markierten Felder vor dem Speichern.'
    },
    Load: {
      Failed: 'Branding-Einstellungen konnten nicht geladen werden.',
      Retry: 'Erneut versuchen'
    }
  },
  [BuilderKey]: {
    StartingPoint: {
      Title: 'Erstellen Sie Ihre Microsite',
      Subtitle: 'Wählen Sie, wie Sie Ihr Kundenportal starten möchten.',
      TemplateTitle: 'Mit einer Vorlage beginnen',
      TemplateDescription:
        'Wählen Sie aus vorgefertigten Layoutprofilen für Treue- und Punktemechaniken.',
      BlankTitle: 'Mit leerer Arbeitsfläche beginnen',
      BlankDescription:
        'Beginnen Sie mit einem leeren Arbeitsbereich und ziehen Sie Komponenten manuell in den Builder.',
      Continue: 'Weiter',
      ReadOnly: 'Sie haben nur Leserechte und können die Microsite daher nicht erstellen.'
    },
    Existing: {
      Title: 'Ihre gespeicherte Microsite',
      Published: 'Veröffentlicht: {{name}}',
      PublishedAt: 'Veröffentlicht am {{date}}',
      Draft: 'Entwurf: {{name}}',
      DraftUpdatedAt: 'Zuletzt gespeichert am {{date}}',
      Label: '{{template}} · {{theme}}',
      BlankCanvas: 'Leere Arbeitsfläche',
      BrandingTheme: 'Globales Branding-Theme',
      TemplateTheme: 'Standard-Theme der Vorlage',
      View: 'Ansehen',
      OverwriteDraft: 'Entwurfsvorlage überschreiben',
      OverwritePublished: 'Veröffentlichte Vorlage überschreiben',
      Duplicate: {
        Title: 'Vorlage bereits vorhanden',
        Published:
          'Diese Vorlage ist bereits veröffentlicht. Um Änderungen vorzunehmen, klicken Sie bitte auf Ansehen, bearbeiten Sie die bestehende Vorlage und veröffentlichen Sie sie erneut.',
        Draft:
          'Diese Vorlage ist bereits als Entwurf vorhanden. Um Änderungen vorzunehmen, klicken Sie bitte auf Ansehen und bearbeiten Sie den bestehenden Entwurf.',
        Close: 'OK'
      },
      Confirm: {
        Title: 'Gespeicherte Seite ersetzen?',
        Published:
          'Sie haben bereits eine veröffentlichte Vorlage ({{current}}). Wenn Sie mit {{next}} beginnen, wird Ihr gespeicherter Entwurf beim Speichern und die Live-Seite beim Veröffentlichen ersetzt. Fortfahren?',
        Draft:
          'Sie haben bereits einen gespeicherten Entwurf ({{current}}). Wenn Sie mit {{next}} beginnen, wird Ihr gespeicherter Entwurf beim Speichern ersetzt. Fortfahren?',
        Continue: 'Weiter',
        Cancel: 'Abbrechen'
      }
    },
    Templates: {
      Title: 'Designvorlage auswählen',
      Subtitle: 'Wählen Sie eine vorintegrierte Vorlage, um Ihr Prämienerlebnis festzulegen.',
      Back: 'Zurück',
      Empty: 'Es sind keine Vorlagen verfügbar.',
      UseSelected: 'Ausgewählte Vorlage verwenden',
      Descriptions: {
        point_utilization: 'Sofortige Punkteeinlösung und Katalogansichten.',
        hybrid_driven: 'Punkte, Challenges und Markenstatistiken im Gleichgewicht.',
        progress_driven: 'Gamifizierte Meilensteine, Level und Punktekennzahlen.',
        reward_driven: 'Angesagte Prämien und standortbasierte Angebote in der Nähe.'
      }
    },
    ThemeSource: {
      Title: 'Theme-Quelle auswählen',
      Description: 'Wählen Sie, woher die Farben und die Typografie für diese Vorlage stammen.',
      TemplateDefault: 'Einstellungen des Standard-Themes der Vorlage verwenden',
      TemplateDefaultHelp:
        'Die vordefinierten Farben und die Typografie der Vorlage auf alle Abschnitte anwenden.',
      Branding: 'Globale Branding-Einstellungen verwenden',
      BrandingHelp:
        'Ihre zuletzt gespeicherten Branding-Farben und -Typografie auf alle Abschnitte anwenden.',
      BrandingBlocked:
        'Das globale Branding ist unvollständig oder ungültig. Vervollständigen und speichern Sie es zuerst im Tab Branding.',
      GoToBranding: 'Zum Branding',
      Confirm: 'Anwenden',
      Cancel: 'Abbrechen'
    },
    Editor: {
      PageStructure: 'Seitenstruktur',
      Sections: 'Abschnitte',
      ReorderHint: 'Abschnitte zum Neuordnen ziehen',
      AddSection: 'Abschnitt hinzufügen',
      AddSectionHint: 'Abschnitte in die Arbeitsfläche ziehen oder zum Hinzufügen klicken',
      Settings: '{{name}}-Einstellungen',
      Layout: 'Layout',
      LayoutUnavailable: 'Für diesen Abschnitt sind noch keine Layouts verfügbar.',
      SelectSection: 'Wählen Sie einen Abschnitt aus, um ihn zu konfigurieren.',
      Card: 'Karte {{number}}',
      NearbyReward: {
        RewardDistance: 'Entfernung zur Prämie'
      },
      CategoryReward: {
        RewardsCategoryFilter: 'Prämienkategoriefilter',
        RewardsCategoryFilterTooltip:
          'Zeigt alle konfigurierten Kategorien an, um Prämien danach zu filtern.'
      },
      PointRedemption: {
        DisplayImage: 'Anzeigebild',
        DisplayImageHint: '{{size}}px mal {{size}}px empfohlen',
        TitleText: 'Titeltext',
        SubtitleText: 'Untertiteltext',
        SemanticText: 'Semantischer Text',
        PointsText: 'Punktetext'
      },
      TransferPoints: {
        DisplayImage: 'Anzeigebild',
        DisplayImageHint: '{{size}}px mal {{size}}px empfohlen',
        BackgroundNumber: 'Hintergrund {{number}}',
        TitleText: 'Titeltext',
        SubtitleText: 'Untertiteltext'
      },
      AvailableChallenges: {
        CampaignTitle: 'Kampagnentitel',
        ChallengeTypeFilter: 'Herausforderungstypfilter',
        ChallengeTypeFilterTooltip:
          'Zeigt alle Herausforderungstypen an, um verfügbare Herausforderungen danach zu filtern.'
      },
      GamesAndChallenges: {
        AppearanceTooltips: {
          Accent1: 'Hintergrund des Neu-Badges',
          Accent2: 'Hintergrund des Bald-Badges',
          Accent3: 'Hintergrund des Enddatum-Badges',
          Semantic1: 'Text des Neu-Badges',
          Semantic2: 'Text des Bald-Badges',
          Semantic3: 'Text des Enddatum-Badges'
        },
        CardBackground: 'Kartenhintergrund',
        ChallengeTitle: 'Titel der Herausforderung',
        DescriptionText: 'Beschreibungstext',
        AccentNumber: 'Akzent {{number}}',
        SemanticNumber: 'Semantik {{number}}',
        Description: 'Beschreibung',
        NewBadge: 'Neu-Badge',
        UpcomingBadge: 'Demnächst-Badge',
        EndDateBadge: 'Enddatum-Badge',
        CarouselContentTooltip:
          'Wählen Sie, wie viele Herausforderungen im Karussell angezeigt werden sollen. Lassen Sie das Feld leer, um alle Herausforderungen mit unendlichem Scrollen anzuzeigen.',
        ChallengesToDisplay: 'Anzuzeigende Herausforderungen',
        SeeAllHint:
          'Führt Benutzer zur Herausforderungsübersicht, um alle Herausforderungen anzuzeigen.'
      },
      FeaturedReward: {
        AccentTooltip: 'Badge-Hintergrund',
        SemanticTooltip: 'Badge-Text',
        Visibility: 'Sichtbarkeit',
        PointsBadge: 'Punkte-Badge',
        RewardTitle: 'Prämientitel',
        MerchantName: 'Händlername',
        SellingDate: 'Verkaufsdatum',
        CarouselContent: 'Karussellinhalt',
        CarouselContentTooltip:
          'Wählen Sie, wie viele Prämien im Karussell angezeigt werden sollen. Lassen Sie das Feld leer, um alle Prämien mit unendlichem Scrollen anzuzeigen.',
        RewardsToDisplay: 'Anzuzeigende Prämien',
        ShowSeeAll: 'Schaltfläche „Alle anzeigen“ anzeigen',
        SeeAllHint: 'Führt Benutzer zur Prämienübersicht, um alle Prämien anzuzeigen.'
      },
      SectionSettings: {
        Title: 'Abschnittseinstellungen',
        ShowTitle: 'Titel anzeigen',
        TitleText: 'Titeltext',
        TranslateTitle: 'Titel übersetzen',
        Translation: 'Übersetzung',
        BackToSettings: 'Zurück zu den Einstellungen',
        TranslationLanguages: {
          en: 'Englisch',
          ar: 'Arabisch',
          fr: 'Französisch',
          id: 'Indonesisch',
          it: 'Italienisch',
          vi: 'Vietnamesisch'
        },
        TextColor: 'Textfarbe',
        SectionBackground: 'Abschnittshintergrund',
        BackgroundColor: 'Hintergrundfarbe',
        Margin: 'Außenabstand',
        Top: 'Oben',
        Bottom: 'Unten'
      },
      Appearance: {
        Title: 'Aussehen',
        ResetToTemplate: 'Auf Vorlage zurücksetzen',
        ResetToBranding: 'Auf Branding zurücksetzen',
        Background: 'Hintergrund',
        CardBackground: 'Kartenhintergrund',
        CardBackground1: 'Kartenhintergrund 1',
        CardBackground2: 'Kartenhintergrund 2',
        RankBackground: 'Ranghintergrund',
        Alternate: 'Alternativ',
        TextNumber: 'Text {{number}}',
        ActiveStreakTextTooltips: {
          Text1: 'Serienanzahl',
          Text2: 'Serienaktivität',
          Text3: 'Beschreibung'
        },
        LeaderboardTextTooltips: {
          Text1: 'Rang',
          Text2: 'Beschriftung',
          Text3: 'Ranglistentitel'
        },
        Text: 'Text',
        TextColor: 'Text',
        ExpiryTextColor: 'Semantik',
        Accent: 'Akzent',
        Semantic: 'Semantik',
        Icon: 'Symbol',
        ButtonType: 'Schaltflächentyp',
        PrimaryButton: 'Primäre Schaltfläche',
        SecondaryButton: 'Sekundäre Schaltfläche'
      }
    },
    Panel: {
      Title: 'Abschnitte',
      Add: 'Abschnitt hinzufügen',
      Empty: 'Noch keine Abschnitte hinzugefügt.',
      MoveUp: '{{name}} nach oben verschieben',
      MoveDown: '{{name}} nach unten verschieben',
      Remove: '{{name}} entfernen',
      LayoutLabel: 'Layout für {{name}}',
      Layouts: {
        Carousel: 'Karussell',
        List: 'Liste',
        Grid: 'Raster'
      },
      QuickLinksLabel: 'Schnelllinks',
      QuickLinksPlaceholder: 'Schnelllinks auswählen',
      QuickActionLabel: 'Aktion {{number}}',
      QuickActionPlaceholder: 'Schnelllink auswählen',
      QuickActionUpload: 'Hochladen',
      QuickActionUploaded: 'Hochgeladen',
      QuickActionUploadLabel: 'Bild für Aktion {{number}} hochladen',
      QuickActionImageHint: '48 × 48 px empfohlen',
      QuickActionImageTooLarge: 'Bilder dürfen höchstens {{size}} KB groß sein',
      QuickActionImageType: 'Lade ein PNG-, JPEG- oder WebP-Bild hoch',
      QuickActionsReset: 'Auf Vorlage zurücksetzen',
      TagLabel: 'Tag',
      TagPlaceholder: 'Tag auswählen',
      TagsLabel: 'Tags',
      TagsInfo: 'Zeigt alle konfigurierten Tags an',
      TagsEmpty: 'Keine Tags konfiguriert.',
      TagUnavailable:
        'Das ausgewählte Tag ist nicht mehr verfügbar. Wählen Sie ein anderes Tag aus.',
      CategoryFilter: 'Kategoriefilter',
      CampaignTypeFilter: 'Kampagnentypfilter',
      SectionIssue: 'Dieser Abschnitt muss vor der Veröffentlichung korrigiert werden.'
    },
    Canvas: {
      Label: 'Landingpage-Canvas',
      Empty: 'Noch keine Abschnitte. Fügen Sie Abschnitte hinzu, um Ihre Landingpage zu erstellen.',
      SelectTag: 'Wählen Sie ein Tag aus, um eine Vorschau dieses Abschnitts anzuzeigen.',
      NoItems: 'In diesem Abschnitt sind noch keine Elemente vorhanden.',
      LoadFailed: 'Vorschauelemente konnten nicht geladen werden.',
      StaticSection: 'Wird auf der Microsite mit Live-Kundendaten angezeigt.',
      LoyaltyCardTitle: 'Punktestand',
      LoyaltyCardHint: 'Stufe und Punkte des Kunden werden hier angezeigt.',
      QuickActionSample1: 'Schnellaktion 1',
      QuickActionSample2: 'Schnellaktion 2',
      QuickActionSample3: 'Schnellaktion 3',
      QuickActionSample4: 'Schnellaktion 4',
      QuickActionsHeadingCard1: 'Holen Sie das Beste aus Ihren Punkten heraus',
      QuickActionsHeadingCard2: 'Der Prämien-Karneval ist da!',
      RewardSampleTitle1: 'Private Weinbergtour',
      RewardSampleTitle2: 'Wellness-Wochenende',
      RewardSampleTitle3: 'Abendessen für zwei',
      RewardSampleMerchant: 'Händlername',
      RewardSampleDistance: '0,3 km',
      CategoryRewardsAllRewards: 'Alle Prämien',
      RewardCta: 'Ansehen',
      ChallengeSampleTitle1: 'Wöchentliche Schritt-Challenge',
      ChallengeSampleTitle2: 'Drehen & Gewinnen',
      ChallengeSampleTitle3: 'Täglicher Check-in',
      ChallengeSampleDescription: 'Abschließen und Bonuspunkte sammeln',
      ActiveStampSampleTitle: 'Titel der Stempelkampagne',
      ActiveRaffleSampleTitle: 'Titel der Verlosung',
      ActiveStamps: 'Stempel',
      ActiveStampProgress: '{{current}}/{{total}} Stempel',
      ActiveTickets: '{{count}} Lose',
      ActiveResume: 'Fortsetzen',
      AllChallenges: 'Alle Herausforderungen',
      ChallengeEndsInDay: 'Endet in {{count}} Tag',
      ChallengeEndsInDays: 'Endet in {{count}} Tagen',
      StreakSampleTitle1: 'Anmelden',
      StreakSampleTitle2: 'Transaktionen',
      StreakSampleTitle3: 'Täglicher Check-in',
      StreakSampleRule1: 'Melden Sie sich 7 Tage in Folge an',
      StreakSampleRule2: '2 Anmeldungen pro Monat für 12 Monate',
      StreakSampleRule3: '10 Tage in Folge einchecken',
      StreakSampleUnit1: 'Anmeldungen',
      StreakSampleUnit2: 'Transaktionen',
      StreakSampleUnit3: 'Check-ins',
      StreakUnitDays: 'Tage',
      StreakLabel: 'Ihre Serie',
      StreakWeekProgress: '{{current}} / {{target}} {{unit}} diese Woche',
      StreakRemaining: 'Nur noch {{count}} {{unit}} diese Woche, um auf Kurs zu bleiben',
      StreakOnTrack: 'Sie sind diese Woche auf Kurs',
      PointRedemptionSampleTitle: 'Punkte in Cashback',
      PointRedemptionSampleDescription: 'Lösen Sie Ihre Punkte als Cashback ein',
      PointRedemptionValue: '{{points}} Punkte = {{value}}',
      PointRedemptionValueShort: '{{points}} Pkt. = {{value}}',
      PointRedemptionUnit: 'Punkte',
      PointRedemptionAccumulated: 'Gesammelte Punkte',
      PointRedemptionCashback: 'Cashback-Wert',
      PointRedemptionCta: 'Jetzt einlösen',
      TransferPointsSampleTitle: 'Punkte übertragen',
      TransferPointsSampleDescription: 'Teilen Sie Punkte mit Freunden und Familie',
      TransferPointsCta: 'Jetzt übertragen',
      Points: '{{points}} Pkt.',
      SeeAll: 'Alle anzeigen',
      ShowLess: 'Weniger anzeigen',
      GoToItem: 'Zu Element {{index}} wechseln',
      Distance: '1,2 km entfernt',
      New: 'Neu',
      Upcoming: 'Demnächst',
      EndsOn: 'Endet am {{date}}',
      LeaderboardRankLabel: 'Dein Ranglistenplatz',
      LeaderboardSampleTitle1: 'Monatliches Punkterennen',
      LeaderboardSampleTitle2: 'Wochenend-Umsatzsprint',
      LeaderboardSampleTitle3: 'Empfehlungs-Champions',
      LeaderboardSampleRank: 'Platz {{rank}}.',
      LeaderboardFeaturedRankSuffix: '.',
      LeaderboardSampleRankSuffix: '.'
    }
  },
  [PublishKey]: {
    Load: {
      Failed: 'Die Landingpage konnte nicht geladen werden.',
      Retry: 'Erneut versuchen'
    },
    Actions: {
      Label: 'Aktionen der Landingpage',
      SaveDraft: 'Speichern',
      Publish: 'Veröffentlichen',
      ChangeStartingPoint: 'Ausgangspunkt ändern',
      Unsaved: 'Ungespeicherte Änderungen',
      DraftSaved: 'Entwurf gespeichert {{date}}',
      Published: 'Veröffentlicht {{date}}',
      NotPublished: 'Noch nicht veröffentlicht'
    },
    Toasts: {
      DraftSaved: 'Entwurf gespeichert.',
      Published: 'Landingpage veröffentlicht.',
      AlreadyPublished: 'Bereits veröffentlicht. Es gibt keine Änderungen zum Veröffentlichen.',
      SaveFailed: 'Der Entwurf konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      PublishFailed:
        'Die Landingpage konnte nicht veröffentlicht werden. Bitte versuchen Sie es erneut.',
      Invalid: 'Beheben Sie die markierten Probleme und versuchen Sie es erneut.'
    },
    Issues: {
      Title: 'Beheben Sie diese Probleme vor dem Veröffentlichen',
      GoToBranding: 'Zum Branding',
      Section: '{{name}}: {{issue}}',
      UnsupportedAttribute: 'Enthält eine nicht unterstützte Einstellung.',
      UnknownSection: 'Dieser Abschnitt ist nicht mehr verfügbar.',
      DuplicateSection: 'Dieser Abschnitt wurde mehrfach hinzugefügt.',
      InvalidLayout: 'Das ausgewählte Layout ist ungültig.',
      LayoutNotAllowed: 'Dieser Abschnitt unterstützt kein Layout.',
      UnknownQuickLink: 'Ein ausgewählter Schnelllink ist nicht mehr verfügbar.',
      DuplicateQuickLink: 'Ein Schnelllink wurde mehrfach ausgewählt.',
      ModuleDisabled: 'Das Modul für diesen Abschnitt ist deaktiviert.',
      InvalidTag: 'Das ausgewählte Tag ist ungültig.',
      TagRequired: 'Wählen Sie ein Tag für diesen Abschnitt aus.',
      TagUnavailable:
        'Das ausgewählte Tag ist nicht mehr verfügbar. Wählen Sie ein anderes Tag aus.',
      ThemeIncomplete:
        'Das Vorlagen-Theme ist unvollständig. Verwenden Sie stattdessen das globale Branding.',
      BrandingInvalid:
        'Das globale Branding enthält ungültige Werte. Korrigieren Sie sie im Tab Branding.',
      BrandingIncomplete: 'Im globalen Branding fehlen Pflichtwerte: {{fields}}.',
      Generic: 'Diese Konfiguration ist ungültig.'
    }
  },
  [PreviewKey]: {
    Open: 'Vorschau',
    Title: 'Vorschau der Landingpage',
    Close: 'Schließen',
    Notice: 'Vorschau Ihrer aktuellen Änderungen. Nichts davon ist veröffentlicht.'
  },
  [ControlKey]: {
    Title: 'Steuerungseinstellungen',
    Description:
      'Microsite-Funktionen ein- oder ausschalten. Änderungen gelten sofort nach dem Umschalten.',
    Flags: {
      show_quest: 'Quests',
      show_nearme: 'In meiner Nähe',
      rewards_carousel: 'Prämien-Karussell',
      show_point_transfer: 'Punkteübertragung',
      show_popup_campaign: 'Pop-up-Kampagnen',
      show_reward_nav_button: 'Prämien-Navigationsschaltfläche',
      show_reward_favourite_button: 'Prämien-Favoritenschaltfläche',
      show_progress_bar_campaigns_on_home_page: 'Fortschrittsbalken-Kampagnen auf der Startseite',
      show_instant_reward_campaigns_on_home_page: 'Sofortprämien-Kampagnen auf der Startseite',
      manual_claim_raffle_ticket: 'Manuelles Einlösen von Losen'
    },
    Toasts: {
      Saved: 'Steuerungseinstellungen gespeichert',
      SaveFailed:
        'Steuerungseinstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.'
    },
    Load: {
      Failed: 'Steuerungseinstellungen konnten nicht geladen werden.',
      Retry: 'Erneut versuchen'
    }
  },
  [GuardKey]: {
    Title: 'Nicht gespeicherte Änderungen verwerfen?',
    Content:
      'Sie haben nicht gespeicherte Änderungen. Diese gehen verloren, wenn Sie diesen Tab verlassen.',
    Discard: 'Verwerfen',
    KeepEditing: 'Weiter bearbeiten'
  }
};
